var cov_25idiwii9c = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Modal/events.tsx",
      hash = "5628ba4011a7958e973ea9f8bf013fcaa4412011",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Modal/events.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "1": {
        start: {
          line: 19,
          column: 17
        },
        end: {
          line: 19,
          column: 20
        }
      },
      "2": {
        start: {
          line: 22,
          column: 14
        },
        end: {
          line: 22,
          column: 29
        }
      },
      "3": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 29
        }
      },
      "4": {
        start: {
          line: 27,
          column: 14
        },
        end: {
          line: 27,
          column: 28
        }
      },
      "5": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 35
        }
      },
      "6": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 98
        }
      },
      "7": {
        start: {
          line: 32,
          column: 43
        },
        end: {
          line: 32,
          column: 97
        }
      },
      "8": {
        start: {
          line: 36,
          column: 14
        },
        end: {
          line: 36,
          column: 105
        }
      },
      "9": {
        start: {
          line: 36,
          column: 50
        },
        end: {
          line: 36,
          column: 104
        }
      },
      "10": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 35
        }
      },
      "11": {
        start: {
          line: 37,
          column: 24
        },
        end: {
          line: 37,
          column: 35
        }
      },
      "12": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 22
        }
      },
      "13": {
        start: {
          line: 42,
          column: 14
        },
        end: {
          line: 42,
          column: 24
        }
      },
      "14": {
        start: {
          line: 43,
          column: 20
        },
        end: {
          line: 43,
          column: 36
        }
      },
      "15": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 44,
          column: 32
        }
      },
      "16": {
        start: {
          line: 44,
          column: 26
        },
        end: {
          line: 44,
          column: 32
        }
      },
      "17": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 45,
          column: 23
        }
      },
      "18": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 46,
          column: 51
        }
      },
      "19": {
        start: {
          line: 46,
          column: 15
        },
        end: {
          line: 46,
          column: 51
        }
      },
      "20": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 47,
          column: 60
        }
      },
      "21": {
        start: {
          line: 47,
          column: 29
        },
        end: {
          line: 47,
          column: 60
        }
      },
      "22": {
        start: {
          line: 51,
          column: 17
        },
        end: {
          line: 51,
          column: 22
        }
      },
      "23": {
        start: {
          line: 52,
          column: 16
        },
        end: {
          line: 52,
          column: 37
        }
      },
      "24": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 47
        }
      },
      "25": {
        start: {
          line: 54,
          column: 41
        },
        end: {
          line: 54,
          column: 47
        }
      },
      "26": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 23
        }
      },
      "27": {
        start: {
          line: 57,
          column: 18
        },
        end: {
          line: 57,
          column: 23
        }
      },
      "28": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 58,
          column: 63
        }
      },
      "29": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 59,
          column: 59
        }
      },
      "30": {
        start: {
          line: 59,
          column: 23
        },
        end: {
          line: 59,
          column: 59
        }
      },
      "31": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 72,
          column: 14
        }
      },
      "32": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 30
        }
      },
      "33": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 43
        }
      },
      "34": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 53
        }
      },
      "35": {
        start: {
          line: 64,
          column: 23
        },
        end: {
          line: 64,
          column: 53
        }
      },
      "36": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "37": {
        start: {
          line: 67,
          column: 18
        },
        end: {
          line: 67,
          column: 57
        }
      },
      "38": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 29
        }
      },
      "39": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 33
        }
      },
      "40": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 28
        }
      },
      "41": {
        start: {
          line: 71,
          column: 18
        },
        end: {
          line: 71,
          column: 28
        }
      },
      "42": {
        start: {
          line: 76,
          column: 27
        },
        end: {
          line: 76,
          column: 48
        }
      },
      "43": {
        start: {
          line: 77,
          column: 79
        },
        end: {
          line: 77,
          column: 84
        }
      },
      "44": {
        start: {
          line: 78,
          column: 12
        },
        end: {
          line: 78,
          column: 28
        }
      },
      "45": {
        start: {
          line: 79,
          column: 2
        },
        end: {
          line: 79,
          column: 21
        }
      },
      "46": {
        start: {
          line: 79,
          column: 11
        },
        end: {
          line: 79,
          column: 21
        }
      },
      "47": {
        start: {
          line: 81,
          column: 17
        },
        end: {
          line: 81,
          column: 74
        }
      },
      "48": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 82,
          column: 37
        }
      },
      "49": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 83,
          column: 25
        }
      },
      "50": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 87,
          column: 3
        }
      },
      "51": {
        start: {
          line: 89,
          column: 2
        },
        end: {
          line: 89,
          column: 53
        }
      },
      "52": {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 91,
          column: 12
        }
      },
      "53": {
        start: {
          line: 96,
          column: 65
        },
        end: {
          line: 96,
          column: 70
        }
      },
      "54": {
        start: {
          line: 97,
          column: 18
        },
        end: {
          line: 97,
          column: 51
        }
      },
      "55": {
        start: {
          line: 98,
          column: 14
        },
        end: {
          line: 98,
          column: 32
        }
      },
      "56": {
        start: {
          line: 99,
          column: 2
        },
        end: {
          line: 99,
          column: 29
        }
      },
      "57": {
        start: {
          line: 100,
          column: 17
        },
        end: {
          line: 100,
          column: 45
        }
      },
      "58": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 101,
          column: 77
        }
      },
      "59": {
        start: {
          line: 101,
          column: 29
        },
        end: {
          line: 101,
          column: 77
        }
      },
      "60": {
        start: {
          line: 102,
          column: 14
        },
        end: {
          line: 102,
          column: 53
        }
      },
      "61": {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 106,
          column: 3
        }
      },
      "62": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 98
        }
      },
      "63": {
        start: {
          line: 104,
          column: 33
        },
        end: {
          line: 104,
          column: 98
        }
      },
      "64": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 33
        }
      },
      "65": {
        start: {
          line: 107,
          column: 22
        },
        end: {
          line: 110,
          column: 3
        }
      },
      "66": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 26
        }
      },
      "67": {
        start: {
          line: 108,
          column: 17
        },
        end: {
          line: 108,
          column: 26
        }
      },
      "68": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 33
        }
      },
      "69": {
        start: {
          line: 109,
          column: 19
        },
        end: {
          line: 109,
          column: 33
        }
      },
      "70": {
        start: {
          line: 112,
          column: 25
        },
        end: {
          line: 112,
          column: 83
        }
      },
      "71": {
        start: {
          line: 113,
          column: 22
        },
        end: {
          line: 113,
          column: 76
        }
      },
      "72": {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 114,
          column: 98
        }
      },
      "73": {
        start: {
          line: 114,
          column: 23
        },
        end: {
          line: 114,
          column: 98
        }
      },
      "74": {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 116,
          column: 38
        }
      },
      "75": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 121,
          column: 12
        }
      },
      "76": {
        start: {
          line: 124,
          column: 2
        },
        end: {
          line: 124,
          column: 56
        }
      },
      "77": {
        start: {
          line: 124,
          column: 16
        },
        end: {
          line: 124,
          column: 56
        }
      },
      "78": {
        start: {
          line: 125,
          column: 2
        },
        end: {
          line: 125,
          column: 119
        }
      },
      "79": {
        start: {
          line: 125,
          column: 73
        },
        end: {
          line: 125,
          column: 119
        }
      },
      "80": {
        start: {
          line: 127,
          column: 2
        },
        end: {
          line: 127,
          column: 29
        }
      },
      "81": {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 128,
          column: 13
        }
      },
      "82": {
        start: {
          line: 131,
          column: 23
        },
        end: {
          line: 150,
          column: 1
        }
      },
      "83": {
        start: {
          line: 131,
          column: 93
        },
        end: {
          line: 150,
          column: 1
        }
      },
      "84": {
        start: {
          line: 133,
          column: 2
        },
        end: {
          line: 133,
          column: 25
        }
      },
      "85": {
        start: {
          line: 133,
          column: 10
        },
        end: {
          line: 133,
          column: 25
        }
      },
      "86": {
        start: {
          line: 134,
          column: 2
        },
        end: {
          line: 149,
          column: 3
        }
      },
      "87": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 137,
          column: 5
        }
      },
      "88": {
        start: {
          line: 136,
          column: 6
        },
        end: {
          line: 136,
          column: 22
        }
      },
      "89": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 146,
          column: 8
        }
      },
      "90": {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 140,
          column: 21
        }
      },
      "91": {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 145,
          column: 9
        }
      },
      "92": {
        start: {
          line: 144,
          column: 10
        },
        end: {
          line: 144,
          column: 27
        }
      },
      "93": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 17
        }
      },
      "94": {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 16
        }
      },
      "95": {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 164,
          column: 5
        }
      },
      "96": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 167,
          column: 5
        }
      },
      "97": {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 166,
          column: 32
        }
      },
      "98": {
        start: {
          line: 171,
          column: 23
        },
        end: {
          line: 171,
          column: 33
        }
      },
      "99": {
        start: {
          line: 172,
          column: 24
        },
        end: {
          line: 172,
          column: 34
        }
      },
      "100": {
        start: {
          line: 173,
          column: 20
        },
        end: {
          line: 173,
          column: 72
        }
      },
      "101": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 178,
          column: 5
        }
      },
      "102": {
        start: {
          line: 191,
          column: 18
        },
        end: {
          line: 198,
          column: 1
        }
      },
      "103": {
        start: {
          line: 192,
          column: 18
        },
        end: {
          line: 192,
          column: 57
        }
      },
      "104": {
        start: {
          line: 193,
          column: 2
        },
        end: {
          line: 197,
          column: 3
        }
      },
      "105": {
        start: {
          line: 200,
          column: 22
        },
        end: {
          line: 223,
          column: 1
        }
      },
      "106": {
        start: {
          line: 200,
          column: 41
        },
        end: {
          line: 223,
          column: 1
        }
      },
      "107": {
        start: {
          line: 201,
          column: 16
        },
        end: {
          line: 213,
          column: 3
        }
      },
      "108": {
        start: {
          line: 215,
          column: 2
        },
        end: {
          line: 219,
          column: 3
        }
      },
      "109": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 216,
          column: 76
        }
      },
      "110": {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 218,
          column: 93
        }
      },
      "111": {
        start: {
          line: 221,
          column: 2
        },
        end: {
          line: 221,
          column: 13
        }
      },
      "112": {
        start: {
          line: 222,
          column: 2
        },
        end: {
          line: 222,
          column: 27
        }
      },
      "113": {
        start: {
          line: 222,
          column: 15
        },
        end: {
          line: 222,
          column: 27
        }
      },
      "114": {
        start: {
          line: 225,
          column: 24
        },
        end: {
          line: 233,
          column: 1
        }
      },
      "115": {
        start: {
          line: 226,
          column: 2
        },
        end: {
          line: 232,
          column: 6
        }
      },
      "116": {
        start: {
          line: 227,
          column: 18
        },
        end: {
          line: 227,
          column: 82
        }
      },
      "117": {
        start: {
          line: 229,
          column: 37
        },
        end: {
          line: 229,
          column: 57
        }
      },
      "118": {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 230,
          column: 28
        }
      },
      "119": {
        start: {
          line: 230,
          column: 19
        },
        end: {
          line: 230,
          column: 28
        }
      },
      "120": {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 231,
          column: 49
        }
      },
      "121": {
        start: {
          line: 231,
          column: 22
        },
        end: {
          line: 231,
          column: 49
        }
      },
      "122": {
        start: {
          line: 235,
          column: 0
        },
        end: {
          line: 246,
          column: 2
        }
      },
      "123": {
        start: {
          line: 236,
          column: 2
        },
        end: {
          line: 245,
          column: 4
        }
      },
      "124": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 237,
          column: 34
        }
      },
      "125": {
        start: {
          line: 237,
          column: 28
        },
        end: {
          line: 237,
          column: 34
        }
      },
      "126": {
        start: {
          line: 238,
          column: 16
        },
        end: {
          line: 238,
          column: 49
        }
      },
      "127": {
        start: {
          line: 239,
          column: 19
        },
        end: {
          line: 239,
          column: 85
        }
      },
      "128": {
        start: {
          line: 239,
          column: 34
        },
        end: {
          line: 239,
          column: 84
        }
      },
      "129": {
        start: {
          line: 240,
          column: 4
        },
        end: {
          line: 240,
          column: 23
        }
      },
      "130": {
        start: {
          line: 240,
          column: 17
        },
        end: {
          line: 240,
          column: 23
        }
      },
      "131": {
        start: {
          line: 241,
          column: 22
        },
        end: {
          line: 241,
          column: 40
        }
      },
      "132": {
        start: {
          line: 242,
          column: 35
        },
        end: {
          line: 242,
          column: 40
        }
      },
      "133": {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 243,
          column: 26
        }
      },
      "134": {
        start: {
          line: 243,
          column: 17
        },
        end: {
          line: 243,
          column: 26
        }
      },
      "135": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 244,
          column: 32
        }
      },
      "136": {
        start: {
          line: 244,
          column: 20
        },
        end: {
          line: 244,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "getDiv",
        decl: {
          start: {
            line: 21,
            column: 9
          },
          end: {
            line: 21,
            column: 15
          }
        },
        loc: {
          start: {
            line: 21,
            column: 29
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 21
      },
      "1": {
        name: "getContainer",
        decl: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 26,
            column: 21
          }
        },
        loc: {
          start: {
            line: 26,
            column: 34
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 26
      },
      "2": {
        name: "hasVisibleMask",
        decl: {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 31,
            column: 23
          }
        },
        loc: {
          start: {
            line: 31,
            column: 26
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 31
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 38
          },
          end: {
            line: 32,
            column: 39
          }
        },
        loc: {
          start: {
            line: 32,
            column: 43
          },
          end: {
            line: 32,
            column: 97
          }
        },
        line: 32
      },
      "4": {
        name: "isMask",
        decl: {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 35,
            column: 15
          }
        },
        loc: {
          start: {
            line: 35,
            column: 28
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 35
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 36,
            column: 45
          },
          end: {
            line: 36,
            column: 46
          }
        },
        loc: {
          start: {
            line: 36,
            column: 50
          },
          end: {
            line: 36,
            column: 104
          }
        },
        line: 36
      },
      "6": {
        name: "destroy",
        decl: {
          start: {
            line: 41,
            column: 16
          },
          end: {
            line: 41,
            column: 23
          }
        },
        loc: {
          start: {
            line: 41,
            column: 54
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 41
      },
      "7": {
        name: "close",
        decl: {
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 21
          }
        },
        loc: {
          start: {
            line: 50,
            column: 59
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 50
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 61,
            column: 13
          },
          end: {
            line: 61,
            column: 14
          }
        },
        loc: {
          start: {
            line: 61,
            column: 19
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 61
      },
      "9": {
        name: "createDiv",
        decl: {
          start: {
            line: 75,
            column: 16
          },
          end: {
            line: 75,
            column: 25
          }
        },
        loc: {
          start: {
            line: 75,
            column: 42
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 75
      },
      "10": {
        name: "open",
        decl: {
          start: {
            line: 95,
            column: 16
          },
          end: {
            line: 95,
            column: 20
          }
        },
        loc: {
          start: {
            line: 95,
            column: 57
          },
          end: {
            line: 129,
            column: 1
          }
        },
        line: 95
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 107,
            column: 22
          },
          end: {
            line: 107,
            column: 23
          }
        },
        loc: {
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 110,
            column: 3
          }
        },
        line: 107
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 131,
            column: 23
          },
          end: {
            line: 131,
            column: 24
          }
        },
        loc: {
          start: {
            line: 131,
            column: 93
          },
          end: {
            line: 150,
            column: 1
          }
        },
        line: 131
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 131,
            column: 93
          },
          end: {
            line: 131,
            column: 94
          }
        },
        loc: {
          start: {
            line: 131,
            column: 99
          },
          end: {
            line: 150,
            column: 1
          }
        },
        line: 131
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 139,
            column: 12
          },
          end: {
            line: 139,
            column: 13
          }
        },
        loc: {
          start: {
            line: 139,
            column: 18
          },
          end: {
            line: 141,
            column: 7
          }
        },
        line: 139
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 142,
            column: 13
          },
          end: {
            line: 142,
            column: 14
          }
        },
        loc: {
          start: {
            line: 142,
            column: 19
          },
          end: {
            line: 146,
            column: 7
          }
        },
        line: 142
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 160,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        loc: {
          start: {
            line: 160,
            column: 37
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 160
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 165,
            column: 22
          },
          end: {
            line: 165,
            column: 23
          }
        },
        loc: {
          start: {
            line: 165,
            column: 33
          },
          end: {
            line: 167,
            column: 5
          }
        },
        line: 165
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 170,
            column: 2
          },
          end: {
            line: 170,
            column: 3
          }
        },
        loc: {
          start: {
            line: 170,
            column: 11
          },
          end: {
            line: 179,
            column: 3
          }
        },
        line: 170
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 191,
            column: 18
          },
          end: {
            line: 191,
            column: 19
          }
        },
        loc: {
          start: {
            line: 191,
            column: 39
          },
          end: {
            line: 198,
            column: 1
          }
        },
        line: 191
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 200,
            column: 22
          },
          end: {
            line: 200,
            column: 23
          }
        },
        loc: {
          start: {
            line: 200,
            column: 41
          },
          end: {
            line: 223,
            column: 1
          }
        },
        line: 200
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 200,
            column: 41
          },
          end: {
            line: 200,
            column: 42
          }
        },
        loc: {
          start: {
            line: 200,
            column: 62
          },
          end: {
            line: 223,
            column: 1
          }
        },
        line: 200
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 222,
            column: 9
          },
          end: {
            line: 222,
            column: 10
          }
        },
        loc: {
          start: {
            line: 222,
            column: 15
          },
          end: {
            line: 222,
            column: 27
          }
        },
        line: 222
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 225,
            column: 24
          },
          end: {
            line: 225,
            column: 25
          }
        },
        loc: {
          start: {
            line: 225,
            column: 30
          },
          end: {
            line: 233,
            column: 1
          }
        },
        line: 225
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 227,
            column: 12
          },
          end: {
            line: 227,
            column: 13
          }
        },
        loc: {
          start: {
            line: 227,
            column: 18
          },
          end: {
            line: 227,
            column: 82
          }
        },
        line: 227
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 228,
            column: 13
          },
          end: {
            line: 228,
            column: 14
          }
        },
        loc: {
          start: {
            line: 228,
            column: 19
          },
          end: {
            line: 232,
            column: 5
          }
        },
        line: 228
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 235,
            column: 6
          },
          end: {
            line: 235,
            column: 7
          }
        },
        loc: {
          start: {
            line: 235,
            column: 12
          },
          end: {
            line: 246,
            column: 1
          }
        },
        line: 235
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 236,
            column: 39
          },
          end: {
            line: 236,
            column: 40
          }
        },
        loc: {
          start: {
            line: 236,
            column: 44
          },
          end: {
            line: 245,
            column: 3
          }
        },
        line: 236
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 239,
            column: 28
          },
          end: {
            line: 239,
            column: 29
          }
        },
        loc: {
          start: {
            line: 239,
            column: 34
          },
          end: {
            line: 239,
            column: 84
          }
        },
        line: 239
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 9
          },
          end: {
            line: 23,
            column: 29
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 23,
            column: 15
          },
          end: {
            line: 23,
            column: 22
          }
        }, {
          start: {
            line: 23,
            column: 25
          },
          end: {
            line: 23,
            column: 29
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 9
          },
          end: {
            line: 28,
            column: 35
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 28,
            column: 15
          },
          end: {
            line: 28,
            column: 28
          }
        }, {
          start: {
            line: 28,
            column: 31
          },
          end: {
            line: 28,
            column: 35
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 43
          },
          end: {
            line: 32,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 43
          },
          end: {
            line: 32,
            column: 64
          }
        }, {
          start: {
            line: 32,
            column: 68
          },
          end: {
            line: 32,
            column: 97
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 50
          },
          end: {
            line: 36,
            column: 104
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 50
          },
          end: {
            line: 36,
            column: 71
          }
        }, {
          start: {
            line: 36,
            column: 75
          },
          end: {
            line: 36,
            column: 104
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 35
          }
        }, {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 35
          }
        }],
        line: 37
      },
      "5": {
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 32
          }
        }, {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 32
          }
        }],
        line: 44
      },
      "6": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 44,
            column: 10
          }
        }, {
          start: {
            line: 44,
            column: 14
          },
          end: {
            line: 44,
            column: 24
          }
        }],
        line: 44
      },
      "7": {
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 51
          }
        }, {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 51
          }
        }],
        line: 46
      },
      "8": {
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 60
          }
        }, {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 60
          }
        }],
        line: 47
      },
      "9": {
        loc: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 9
          }
        }, {
          start: {
            line: 47,
            column: 13
          },
          end: {
            line: 47,
            column: 27
          }
        }],
        line: 47
      },
      "10": {
        loc: {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 47
          }
        }, {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 47
          }
        }],
        line: 54
      },
      "11": {
        loc: {
          start: {
            line: 54,
            column: 6
          },
          end: {
            line: 54,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 6
          },
          end: {
            line: 54,
            column: 12
          }
        }, {
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 54,
            column: 39
          }
        }],
        line: 54
      },
      "12": {
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 59
          }
        }, {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 59
          }
        }],
        line: 59
      },
      "13": {
        loc: {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 64,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 64,
            column: 53
          }
        }, {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 64,
            column: 53
          }
        }],
        line: 64
      },
      "14": {
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 66
      },
      "15": {
        loc: {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 28
          }
        }, {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 28
          }
        }],
        line: 71
      },
      "16": {
        loc: {
          start: {
            line: 77,
            column: 36
          },
          end: {
            line: 77,
            column: 64
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 77,
            column: 48
          },
          end: {
            line: 77,
            column: 64
          }
        }],
        line: 77
      },
      "17": {
        loc: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 21
          }
        }, {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 21
          }
        }],
        line: 79
      },
      "18": {
        loc: {
          start: {
            line: 81,
            column: 17
          },
          end: {
            line: 81,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 81,
            column: 51
          },
          end: {
            line: 81,
            column: 62
          }
        }, {
          start: {
            line: 81,
            column: 65
          },
          end: {
            line: 81,
            column: 74
          }
        }],
        line: 81
      },
      "19": {
        loc: {
          start: {
            line: 85,
            column: 20
          },
          end: {
            line: 85,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 20
          },
          end: {
            line: 85,
            column: 28
          }
        }, {
          start: {
            line: 85,
            column: 32
          },
          end: {
            line: 85,
            column: 42
          }
        }],
        line: 85
      },
      "20": {
        loc: {
          start: {
            line: 85,
            column: 44
          },
          end: {
            line: 85,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 44
          },
          end: {
            line: 85,
            column: 51
          }
        }, {
          start: {
            line: 85,
            column: 55
          },
          end: {
            line: 85,
            column: 60
          }
        }],
        line: 85
      },
      "21": {
        loc: {
          start: {
            line: 85,
            column: 62
          },
          end: {
            line: 85,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 62
          },
          end: {
            line: 85,
            column: 72
          }
        }, {
          start: {
            line: 85,
            column: 76
          },
          end: {
            line: 85,
            column: 89
          }
        }],
        line: 85
      },
      "22": {
        loc: {
          start: {
            line: 85,
            column: 91
          },
          end: {
            line: 85,
            column: 114
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 91
          },
          end: {
            line: 85,
            column: 99
          }
        }, {
          start: {
            line: 85,
            column: 103
          },
          end: {
            line: 85,
            column: 114
          }
        }],
        line: 85
      },
      "23": {
        loc: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 77
          }
        }, {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 77
          }
        }],
        line: 101
      },
      "24": {
        loc: {
          start: {
            line: 103,
            column: 2
          },
          end: {
            line: 106,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 2
          },
          end: {
            line: 106,
            column: 3
          }
        }, {
          start: {
            line: 103,
            column: 2
          },
          end: {
            line: 106,
            column: 3
          }
        }],
        line: 103
      },
      "25": {
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 98
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 98
          }
        }, {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 98
          }
        }],
        line: 104
      },
      "26": {
        loc: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 26
          }
        }, {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 26
          }
        }],
        line: 108
      },
      "27": {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 109,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 109,
            column: 33
          }
        }, {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 109,
            column: 33
          }
        }],
        line: 109
      },
      "28": {
        loc: {
          start: {
            line: 112,
            column: 25
          },
          end: {
            line: 112,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 59
          },
          end: {
            line: 112,
            column: 63
          }
        }, {
          start: {
            line: 112,
            column: 66
          },
          end: {
            line: 112,
            column: 83
          }
        }],
        line: 112
      },
      "29": {
        loc: {
          start: {
            line: 113,
            column: 22
          },
          end: {
            line: 113,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 113,
            column: 55
          },
          end: {
            line: 113,
            column: 69
          }
        }, {
          start: {
            line: 113,
            column: 72
          },
          end: {
            line: 113,
            column: 76
          }
        }],
        line: 113
      },
      "30": {
        loc: {
          start: {
            line: 113,
            column: 22
          },
          end: {
            line: 113,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 22
          },
          end: {
            line: 113,
            column: 39
          }
        }, {
          start: {
            line: 113,
            column: 43
          },
          end: {
            line: 113,
            column: 52
          }
        }],
        line: 113
      },
      "31": {
        loc: {
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 114,
            column: 98
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 114,
            column: 98
          }
        }, {
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 114,
            column: 98
          }
        }],
        line: 114
      },
      "32": {
        loc: {
          start: {
            line: 114,
            column: 46
          },
          end: {
            line: 114,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 114,
            column: 46
          },
          end: {
            line: 114,
            column: 66
          }
        }, {
          start: {
            line: 114,
            column: 70
          },
          end: {
            line: 114,
            column: 98
          }
        }],
        line: 114
      },
      "33": {
        loc: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 56
          }
        }, {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 56
          }
        }],
        line: 124
      },
      "34": {
        loc: {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 125,
            column: 119
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 125,
            column: 119
          }
        }, {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 125,
            column: 119
          }
        }],
        line: 125
      },
      "35": {
        loc: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 28
          }
        }, {
          start: {
            line: 125,
            column: 32
          },
          end: {
            line: 125,
            column: 71
          }
        }],
        line: 125
      },
      "36": {
        loc: {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 25
          }
        }, {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 25
          }
        }],
        line: 133
      },
      "37": {
        loc: {
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 149,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 149,
            column: 3
          }
        }, {
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 149,
            column: 3
          }
        }],
        line: 134
      },
      "38": {
        loc: {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 134,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 134,
            column: 14
          }
        }, {
          start: {
            line: 134,
            column: 18
          },
          end: {
            line: 134,
            column: 53
          }
        }],
        line: 134
      },
      "39": {
        loc: {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        }, {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 137,
            column: 5
          }
        }],
        line: 135
      },
      "40": {
        loc: {
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 145,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 145,
            column: 9
          }
        }, {
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 145,
            column: 9
          }
        }],
        line: 143
      },
      "41": {
        loc: {
          start: {
            line: 215,
            column: 2
          },
          end: {
            line: 219,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 215,
            column: 2
          },
          end: {
            line: 219,
            column: 3
          }
        }, {
          start: {
            line: 215,
            column: 2
          },
          end: {
            line: 219,
            column: 3
          }
        }],
        line: 215
      },
      "42": {
        loc: {
          start: {
            line: 218,
            column: 19
          },
          end: {
            line: 218,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 218,
            column: 39
          },
          end: {
            line: 218,
            column: 51
          }
        }, {
          start: {
            line: 218,
            column: 54
          },
          end: {
            line: 218,
            column: 93
          }
        }],
        line: 218
      },
      "43": {
        loc: {
          start: {
            line: 227,
            column: 18
          },
          end: {
            line: 227,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 18
          },
          end: {
            line: 227,
            column: 56
          }
        }, {
          start: {
            line: 227,
            column: 60
          },
          end: {
            line: 227,
            column: 82
          }
        }],
        line: 227
      },
      "44": {
        loc: {
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 230,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 230,
            column: 28
          }
        }, {
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 230,
            column: 28
          }
        }],
        line: 230
      },
      "45": {
        loc: {
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 231,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 231,
            column: 49
          }
        }, {
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 231,
            column: 49
          }
        }],
        line: 231
      },
      "46": {
        loc: {
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 237,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 237,
            column: 34
          }
        }, {
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 237,
            column: 34
          }
        }],
        line: 237
      },
      "47": {
        loc: {
          start: {
            line: 239,
            column: 34
          },
          end: {
            line: 239,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 239,
            column: 34
          },
          end: {
            line: 239,
            column: 56
          }
        }, {
          start: {
            line: 239,
            column: 60
          },
          end: {
            line: 239,
            column: 84
          }
        }],
        line: 239
      },
      "48": {
        loc: {
          start: {
            line: 240,
            column: 4
          },
          end: {
            line: 240,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 240,
            column: 4
          },
          end: {
            line: 240,
            column: 23
          }
        }, {
          start: {
            line: 240,
            column: 4
          },
          end: {
            line: 240,
            column: 23
          }
        }],
        line: 240
      },
      "49": {
        loc: {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 243,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 243,
            column: 26
          }
        }, {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 243,
            column: 26
          }
        }],
        line: 243
      },
      "50": {
        loc: {
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 244,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 244,
            column: 32
          }
        }, {
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 244,
            column: 32
          }
        }],
        line: 244
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Modal/events.tsx",
    _this2 = this;

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { PureComponent } from '../component';
import Button from '../Button';
import { getUidStr } from '../utils/uid';
import { modalClass } from './styles';
import Panel from './Panel';
import { getLocale } from '../locale';
import { getParent } from '../utils/dom/element';
import ready from '../utils/dom/ready';
import { docSize } from '../utils/dom/document';
import { isRTL, getDefaultContainer } from '../config';
var containers = (cov_25idiwii9c.s[0]++, {});
var DURATION = (cov_25idiwii9c.s[1]++, 300);

function getDiv(id) {
  cov_25idiwii9c.f[0]++;
  var mod = (cov_25idiwii9c.s[2]++, containers[id]);
  cov_25idiwii9c.s[3]++;
  return mod ? (cov_25idiwii9c.b[0][0]++, mod.div) : (cov_25idiwii9c.b[0][1]++, null);
}

function getContainer(id) {
  cov_25idiwii9c.f[1]++;
  var mod = (cov_25idiwii9c.s[4]++, containers[id]);
  cov_25idiwii9c.s[5]++;
  return mod ? (cov_25idiwii9c.b[1][0]++, mod.container) : (cov_25idiwii9c.b[1][1]++, null);
}

function hasVisibleMask() {
  cov_25idiwii9c.f[2]++;
  cov_25idiwii9c.s[6]++;
  return Object.keys(containers).some(function (k) {
    cov_25idiwii9c.f[3]++;
    cov_25idiwii9c.s[7]++;
    return (cov_25idiwii9c.b[2][0]++, containers[k].visible) && (cov_25idiwii9c.b[2][1]++, !containers[k].props.hideMask);
  });
}

function isMask(id) {
  cov_25idiwii9c.f[4]++;
  var ids = (cov_25idiwii9c.s[8]++, Object.keys(containers).filter(function (k) {
    cov_25idiwii9c.f[5]++;
    cov_25idiwii9c.s[9]++;
    return (cov_25idiwii9c.b[3][0]++, containers[k].visible) && (cov_25idiwii9c.b[3][1]++, !containers[k].props.hideMask);
  }));
  cov_25idiwii9c.s[10]++;

  if (ids.length === 0) {
    cov_25idiwii9c.b[4][0]++;
    cov_25idiwii9c.s[11]++;
    return true;
  } else {
    cov_25idiwii9c.b[4][1]++;
  }

  cov_25idiwii9c.s[12]++;
  return ids[0] === id;
}

export function destroy(id, unmount) {
  cov_25idiwii9c.f[6]++;
  var div = (cov_25idiwii9c.s[13]++, getDiv(id));
  var container = (cov_25idiwii9c.s[14]++, getContainer(id));
  cov_25idiwii9c.s[15]++;

  if ((cov_25idiwii9c.b[6][0]++, !div) || (cov_25idiwii9c.b[6][1]++, !container)) {
    cov_25idiwii9c.b[5][0]++;
    cov_25idiwii9c.s[16]++;
    return;
  } else {
    cov_25idiwii9c.b[5][1]++;
  }

  cov_25idiwii9c.s[17]++;
  delete containers[id];
  cov_25idiwii9c.s[18]++;

  if (unmount) {
    cov_25idiwii9c.b[7][0]++;
    cov_25idiwii9c.s[19]++;
    ReactDOM.unmountComponentAtNode(div);
  } else {
    cov_25idiwii9c.b[7][1]++;
  }

  cov_25idiwii9c.s[20]++;

  if ((cov_25idiwii9c.b[9][0]++, div) && (cov_25idiwii9c.b[9][1]++, div.parentNode)) {
    cov_25idiwii9c.b[8][0]++;
    cov_25idiwii9c.s[21]++;
    div.parentNode.removeChild(div);
  } else {
    cov_25idiwii9c.b[8][1]++;
  }
}
export function close(props, callback) {
  cov_25idiwii9c.f[7]++;

  var _ref = (cov_25idiwii9c.s[22]++, props),
      id = _ref.id;

  var modal = (cov_25idiwii9c.s[23]++, containers[props.id]);
  cov_25idiwii9c.s[24]++;

  if ((cov_25idiwii9c.b[11][0]++, !modal) || (cov_25idiwii9c.b[11][1]++, modal.visible === false)) {
    cov_25idiwii9c.b[10][0]++;
    cov_25idiwii9c.s[25]++;
    return;
  } else {
    cov_25idiwii9c.b[10][1]++;
  }

  cov_25idiwii9c.s[26]++;
  modal.visible = false;

  var _ref2 = (cov_25idiwii9c.s[27]++, modal),
      div = _ref2.div;

  cov_25idiwii9c.s[28]++;
  div.classList.remove(modalClass('show'), modalClass('start'));
  cov_25idiwii9c.s[29]++;

  if (!props.position) {
    cov_25idiwii9c.b[12][0]++;
    cov_25idiwii9c.s[30]++;
    div.classList.add(modalClass('end'));
  } else {
    cov_25idiwii9c.b[12][1]++;
  }

  cov_25idiwii9c.s[31]++;
  setTimeout(function () {
    cov_25idiwii9c.f[8]++;
    cov_25idiwii9c.s[32]++;
    div.style.display = 'none';
    cov_25idiwii9c.s[33]++;
    div.classList.remove(modalClass('end'));
    cov_25idiwii9c.s[34]++;

    if (props.destroy) {
      cov_25idiwii9c.b[13][0]++;
      cov_25idiwii9c.s[35]++;
      destroy(id, !props.usePortal);
    } else {
      cov_25idiwii9c.b[13][1]++;
    }

    cov_25idiwii9c.s[36]++;

    if (!hasVisibleMask()) {
      cov_25idiwii9c.b[14][0]++;
      var doc = (cov_25idiwii9c.s[37]++, document.body.parentNode);
      cov_25idiwii9c.s[38]++;
      doc.style.overflow = '';
      cov_25idiwii9c.s[39]++;
      doc.style.paddingRight = '';
    } else {
      cov_25idiwii9c.b[14][1]++;
    }

    cov_25idiwii9c.s[40]++;

    if (callback) {
      cov_25idiwii9c.b[15][0]++;
      cov_25idiwii9c.s[41]++;
      callback();
    } else {
      cov_25idiwii9c.b[15][1]++;
    }
  }, DURATION);
}
export function createDiv(props) {
  cov_25idiwii9c.f[9]++;
  var defaultContainer = (cov_25idiwii9c.s[42]++, getDefaultContainer());

  var _ref3 = (cov_25idiwii9c.s[43]++, props),
      id = _ref3.id,
      position = _ref3.position,
      fullScreen = _ref3.fullScreen,
      _ref3$container = _ref3.container,
      container = _ref3$container === void 0 ? (cov_25idiwii9c.b[16][0]++, defaultContainer) : _ref3$container,
      hideMask = _ref3.hideMask;

  var div = (cov_25idiwii9c.s[44]++, getDiv(props.id));
  cov_25idiwii9c.s[45]++;

  if (div) {
    cov_25idiwii9c.b[17][0]++;
    cov_25idiwii9c.s[46]++;
    return div;
  } else {
    cov_25idiwii9c.b[17][1]++;
  }

  var parent = (cov_25idiwii9c.s[47]++, typeof container === 'function' ? (cov_25idiwii9c.b[18][0]++, container()) : (cov_25idiwii9c.b[18][1]++, container));
  cov_25idiwii9c.s[48]++;
  div = document.createElement('div');
  cov_25idiwii9c.s[49]++;
  parent.appendChild(div);
  cov_25idiwii9c.s[50]++;
  div.className = classnames(modalClass('_', (cov_25idiwii9c.b[19][0]++, position) && (cov_25idiwii9c.b[19][1]++, 'position'), (cov_25idiwii9c.b[20][0]++, isRTL()) && (cov_25idiwii9c.b[20][1]++, 'rtl'), (cov_25idiwii9c.b[21][0]++, fullScreen) && (cov_25idiwii9c.b[21][1]++, 'full-screen'), (cov_25idiwii9c.b[22][0]++, hideMask) && (cov_25idiwii9c.b[22][1]++, 'hide-mask')), props.rootClassName);
  cov_25idiwii9c.s[51]++;
  containers[id] = {
    div: div,
    container: parent,
    props: props
  };
  cov_25idiwii9c.s[52]++;
  return div;
} // eslint-disable-next-line

export function open(props, isPortal) {
  cov_25idiwii9c.f[10]++;

  var _ref4 = (cov_25idiwii9c.s[53]++, props),
      content = _ref4.content,
      onClose = _ref4.onClose,
      zIndex = _ref4.zIndex,
      forceMask = _ref4.forceMask,
      otherProps = _objectWithoutProperties(_ref4, ["content", "onClose", "zIndex", "forceMask"]);

  var options = (cov_25idiwii9c.s[54]++, _objectSpread2(_objectSpread2({}, props), {}, {
    usePortal: isPortal
  }));
  var div = (cov_25idiwii9c.s[55]++, createDiv(options));
  cov_25idiwii9c.s[56]++;
  div.style.display = 'block';
  var parsed = (cov_25idiwii9c.s[57]++, parseInt(String(zIndex), 10));
  cov_25idiwii9c.s[58]++;

  if (!Number.isNaN(parsed)) {
    cov_25idiwii9c.b[23][0]++;
    cov_25idiwii9c.s[59]++;
    div.style.zIndex = parsed;
  } else {
    cov_25idiwii9c.b[23][1]++;
  }

  var doc = (cov_25idiwii9c.s[60]++, document.body.parentNode);
  cov_25idiwii9c.s[61]++;

  if (!props.hideMask) {
    cov_25idiwii9c.b[24][0]++;
    cov_25idiwii9c.s[62]++;

    if (!doc.style.paddingRight) {
      cov_25idiwii9c.b[25][0]++;
      cov_25idiwii9c.s[63]++;
      doc.style.paddingRight = "".concat(window.innerWidth - docSize.width, "px");
    } else {
      cov_25idiwii9c.b[25][1]++;
    }

    cov_25idiwii9c.s[64]++;
    doc.style.overflow = 'hidden';
  } else {
    cov_25idiwii9c.b[24][1]++;
  }

  cov_25idiwii9c.s[65]++;

  var handleClose = function handleClose() {
    cov_25idiwii9c.f[11]++;
    cov_25idiwii9c.s[66]++;

    if (onClose) {
      cov_25idiwii9c.b[26][0]++;
      cov_25idiwii9c.s[67]++;
      onClose();
    } else {
      cov_25idiwii9c.b[26][1]++;
    }

    cov_25idiwii9c.s[68]++;

    if (!isPortal) {
      cov_25idiwii9c.b[27][0]++;
      cov_25idiwii9c.s[69]++;
      close(options);
    } else {
      cov_25idiwii9c.b[27][1]++;
    }
  };

  var opacityDefault = (cov_25idiwii9c.s[70]++, props.maskOpacity === undefined ? (cov_25idiwii9c.b[28][0]++, 0.25) : (cov_25idiwii9c.b[28][1]++, props.maskOpacity));
  var maskOpacity = (cov_25idiwii9c.s[71]++, (cov_25idiwii9c.b[30][0]++, isMask(props.id)) || (cov_25idiwii9c.b[30][1]++, forceMask) ? (cov_25idiwii9c.b[29][0]++, opacityDefault) : (cov_25idiwii9c.b[29][1]++, 0.01));
  cov_25idiwii9c.s[72]++;

  if (!props.hideMask) {
    cov_25idiwii9c.b[31][0]++;
    cov_25idiwii9c.s[73]++;
    div.style.background = (cov_25idiwii9c.b[32][0]++, props.maskBackground) || (cov_25idiwii9c.b[32][1]++, "rgba(0,0,0,".concat(maskOpacity, ")"));
  } else {
    cov_25idiwii9c.b[31][1]++;
  }

  cov_25idiwii9c.s[74]++;
  containers[props.id].visible = true;
  var panel = (cov_25idiwii9c.s[75]++,
  /*#__PURE__*/
  React.createElement(Panel, Object.assign({}, otherProps, {
    onClose: handleClose,
    container: div,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 5
    }
  }), content));
  cov_25idiwii9c.s[76]++;

  if (isPortal) {
    cov_25idiwii9c.b[33][0]++;
    cov_25idiwii9c.s[77]++;
    return (
      /*#__PURE__*/
      ReactDOM.createPortal(panel, div)
    );
  } else {
    cov_25idiwii9c.b[33][1]++;
  }

  cov_25idiwii9c.s[78]++;

  if ((cov_25idiwii9c.b[35][0]++, document.activeElement) && (cov_25idiwii9c.b[35][1]++, !getParent(document.activeElement, div))) {
    cov_25idiwii9c.b[34][0]++;
    cov_25idiwii9c.s[79]++;
    document.activeElement.blur();
  } else {
    cov_25idiwii9c.b[34][1]++;
  }

  cov_25idiwii9c.s[80]++;
  ReactDOM.render(panel, div);
  cov_25idiwii9c.s[81]++;
  return null;
}
cov_25idiwii9c.s[82]++;

var closeCallback = function closeCallback(fn, option, setLoading) {
  cov_25idiwii9c.f[12]++;
  cov_25idiwii9c.s[83]++;
  return function () {
    cov_25idiwii9c.f[13]++;
    var callback;
    cov_25idiwii9c.s[84]++;

    if (fn) {
      cov_25idiwii9c.b[36][0]++;
      cov_25idiwii9c.s[85]++;
      callback = fn();
    } else {
      cov_25idiwii9c.b[36][1]++;
    }

    cov_25idiwii9c.s[86]++;

    if ((cov_25idiwii9c.b[38][0]++, callback) && (cov_25idiwii9c.b[38][1]++, typeof callback.then === 'function')) {
      cov_25idiwii9c.b[37][0]++;
      cov_25idiwii9c.s[87]++;

      if (setLoading) {
        cov_25idiwii9c.b[39][0]++;
        cov_25idiwii9c.s[88]++;
        setLoading(true);
      } else {
        cov_25idiwii9c.b[39][1]++;
      }

      cov_25idiwii9c.s[89]++;
      callback.then(function () {
        cov_25idiwii9c.f[14]++;
        cov_25idiwii9c.s[90]++;
        close(option);
      })["catch"](function () {
        cov_25idiwii9c.f[15]++;
        cov_25idiwii9c.s[91]++;

        if (setLoading) {
          cov_25idiwii9c.b[40][0]++;
          cov_25idiwii9c.s[92]++;
          setLoading(false);
        } else {
          cov_25idiwii9c.b[40][1]++;
        }
      });
    } else {
      cov_25idiwii9c.b[37][1]++;
      cov_25idiwii9c.s[93]++;
      close(option);
    }
  };
};

var LoadingOk =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LoadingOk, _PureComponent);

  var _super = _createSuper2(LoadingOk);

  function LoadingOk(props) {
    var _this;

    _classCallCheck(this, LoadingOk);

    cov_25idiwii9c.f[16]++;
    cov_25idiwii9c.s[94]++;
    _this = _super.call(this, props);
    _this.setLoading = void 0;
    cov_25idiwii9c.s[95]++;
    _this.state = {
      loading: false
    };
    cov_25idiwii9c.s[96]++;

    _this.setLoading = function (loading) {
      cov_25idiwii9c.f[17]++;
      cov_25idiwii9c.s[97]++;

      _this.setState({
        loading: loading
      });
    };

    return _this;
  }

  _createClass(LoadingOk, [{
    key: "render",
    value: function render() {
      cov_25idiwii9c.f[18]++;

      var _ref5 = (cov_25idiwii9c.s[98]++, this.props),
          option = _ref5.option;

      var _ref6 = (cov_25idiwii9c.s[99]++, this.state),
          loading = _ref6.loading;

      var onClick = (cov_25idiwii9c.s[100]++, closeCallback(option.onOk, option, this.setLoading));
      cov_25idiwii9c.s[101]++;
      return (
        /*#__PURE__*/
        React.createElement(Button, {
          loading: loading,
          key: "ok",
          id: "".concat(option.id, "-ok"),
          onClick: onClick,
          type: "primary",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 175,
            columnNumber: 7
          }
        }, getLocale('ok', option.text))
      );
    }
  }]);

  return LoadingOk;
}(PureComponent); // const btnOk = option => {
//   const onClick = closeCallback(option.onOk, option)
//   return (
//     <Button.Once key="ok" id={`${option.id}-ok`} onClick={onClick} type="primary">
//       {getLocale('ok', option.text)}
//     </Button.Once>
//   )
// }


cov_25idiwii9c.s[102]++;

var btnCancel = function btnCancel(option) {
  cov_25idiwii9c.f[19]++;
  var onClick = (cov_25idiwii9c.s[103]++, closeCallback(option.onCancel, option));
  cov_25idiwii9c.s[104]++;
  return (
    /*#__PURE__*/
    React.createElement(Button.Once, {
      id: "".concat(option.id, "-cancel"),
      key: "cancel",
      onClick: onClick,
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 194,
        columnNumber: 5
      }
    }, getLocale('cancel', option.text))
  );
};

cov_25idiwii9c.s[105]++;
export var method = function method(type) {
  cov_25idiwii9c.f[20]++;
  cov_25idiwii9c.s[106]++;
  return function (option) {
    cov_25idiwii9c.f[21]++;
    var props = (cov_25idiwii9c.s[107]++, Object.assign({
      width: 420,
      esc: true
    }, option, {
      id: getUidStr(),
      destroy: true,
      type: type,
      from: 'method'
    }));
    cov_25idiwii9c.s[108]++;

    if (type === 'confirm') {
      cov_25idiwii9c.b[41][0]++;
      cov_25idiwii9c.s[109]++;
      props.footer = [btnCancel(props),
      /*#__PURE__*/
      React.createElement(LoadingOk, {
        option: props,
        key: "ok",
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 216,
          columnNumber: 39
        }
      })];
    } else {
      cov_25idiwii9c.b[41][1]++;
      cov_25idiwii9c.s[110]++;
      props.footer = 'footer' in props ? (cov_25idiwii9c.b[42][0]++, props.footer) : (cov_25idiwii9c.b[42][1]++, [
      /*#__PURE__*/
      React.createElement(LoadingOk, {
        option: props,
        key: "ok",
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 218,
          columnNumber: 56
        }
      })]);
    }

    cov_25idiwii9c.s[111]++;
    open(props);
    cov_25idiwii9c.s[112]++;
    return function () {
      cov_25idiwii9c.f[22]++;
      cov_25idiwii9c.s[113]++;
      return close(props);
    };
  };
};
cov_25idiwii9c.s[114]++;
export var closeAll = function closeAll() {
  cov_25idiwii9c.f[23]++;
  cov_25idiwii9c.s[115]++;
  Object.keys(containers).filter(function (id) {
    cov_25idiwii9c.f[24]++;
    cov_25idiwii9c.s[116]++;
    return (cov_25idiwii9c.b[43][0]++, containers[id].props.from === 'method') && (cov_25idiwii9c.b[43][1]++, containers[id].visible);
  }).forEach(function (id) {
    cov_25idiwii9c.f[25]++;

    var _ref7 = (cov_25idiwii9c.s[117]++, containers[id].props),
        onClose = _ref7.onClose,
        usePortal = _ref7.usePortal;

    cov_25idiwii9c.s[118]++;

    if (onClose) {
      cov_25idiwii9c.b[44][0]++;
      cov_25idiwii9c.s[119]++;
      onClose();
    } else {
      cov_25idiwii9c.b[44][1]++;
    }

    cov_25idiwii9c.s[120]++;

    if (!usePortal) {
      cov_25idiwii9c.b[45][0]++;
      cov_25idiwii9c.s[121]++;
      close(containers[id].props);
    } else {
      cov_25idiwii9c.b[45][1]++;
    }
  });
};
cov_25idiwii9c.s[122]++;
ready(function () {
  cov_25idiwii9c.f[26]++;
  cov_25idiwii9c.s[123]++;
  document.addEventListener('keydown', function (e) {
    cov_25idiwii9c.f[27]++;
    cov_25idiwii9c.s[124]++;

    if (e.key !== 'Escape') {
      cov_25idiwii9c.b[46][0]++;
      cov_25idiwii9c.s[125]++;
      return;
    } else {
      cov_25idiwii9c.b[46][1]++;
    }

    var ids = (cov_25idiwii9c.s[126]++, Object.keys(containers).reverse());
    var opened = (cov_25idiwii9c.s[127]++, ids.find(function (id) {
      cov_25idiwii9c.f[28]++;
      cov_25idiwii9c.s[128]++;
      return (cov_25idiwii9c.b[47][0]++, containers[id].visible) && (cov_25idiwii9c.b[47][1]++, containers[id].props.esc);
    }));
    cov_25idiwii9c.s[129]++;

    if (!opened) {
      cov_25idiwii9c.b[48][0]++;
      cov_25idiwii9c.s[130]++;
      return;
    } else {
      cov_25idiwii9c.b[48][1]++;
    }

    var _ref8 = (cov_25idiwii9c.s[131]++, containers[opened]),
        props = _ref8.props;

    var _ref9 = (cov_25idiwii9c.s[132]++, props),
        onClose = _ref9.onClose,
        usePortal = _ref9.usePortal;

    cov_25idiwii9c.s[133]++;

    if (onClose) {
      cov_25idiwii9c.b[49][0]++;
      cov_25idiwii9c.s[134]++;
      onClose();
    } else {
      cov_25idiwii9c.b[49][1]++;
    }

    cov_25idiwii9c.s[135]++;

    if (!usePortal) {
      cov_25idiwii9c.b[50][0]++;
      cov_25idiwii9c.s[136]++;
      close(props);
    } else {
      cov_25idiwii9c.b[50][1]++;
    }
  });
});